import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.SCANS,
  displayName: "Advanced Security Scans",
  displayOrder: 4,
  isCustomerFacing: false,
};

export default entitlement;
